export {default as Segmented} from './Segmented';

export {ArrowBtn, ArrowSpanBtn, NormalBtn, NormalSpanBtn} from './Button';

export {default as SubTitle} from './SubTitle';
